import { Modal as ChakraModal, ModalProps as ChakraModalProps } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React from 'react';

import DisplayNames from './enums';

type ModalSizeOption = 'sm' | 'md' | 'lg' | 'xl' | 'full';
type ModalVariantOption = 'basic' | 'media' | 'tabbed';

export const modalSizePropTypes: ModalSizeOption[] = ['sm', 'md', 'lg', 'xl', 'full'];
export const modalVariantPropTypes: ModalVariantOption[] = ['basic', 'media', 'tabbed'];

const propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  autoFocus: PropTypes.bool,
  closeOnOverlayClick: PropTypes.bool,
  isCentered: PropTypes.bool,
  size: PropTypes.oneOf(modalSizePropTypes),
  variant: PropTypes.oneOf(modalVariantPropTypes)
};
const defaultProps = {
  closeOnOverlayClick: true,
  isCentered: true,
  autoFocus: false,
  size: 'lg',
  variant: 'basic'
};

export type ModalProps = Omit<ChakraModalProps, 'size' | 'variant' | 'closeOnEsc'> & {
  size?: string;
  variant?: string;
};

const Modal = (props: ModalProps & typeof defaultProps): React.ReactElement => {
  return <ChakraModal closeOnEsc {...props} />;
};

Modal.propTypes = propTypes;
Modal.defaultProps = defaultProps;
Modal.displayName = DisplayNames.Modal;

export default Modal;
